import { AfterViewInit, Component, OnInit } from '@angular/core';
import { embedDashboard } from '@superset-ui/embedded-sdk';
import { SupersetEmbeddedService } from 'src/app/services/superset-embedded.service';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';
import { HttpErrorResponse } from '@angular/common/http';
import { SupersetDashboardService } from 'src/app/services/superset-dashboard.service';

@Component({
  selector: 'app-superset-embedded',
  templateUrl: './superset-embedded.component.html',
  styleUrls: ['./superset-embedded.component.scss']
})
export class SupersetEmbeddedComponent implements OnInit {

  private supersetUrl = 'https://graph.servicios.gt/';
  private dashboardId = '1';
  private dashboardOriginalId = '';

  constructor(private supersetService: SupersetEmbeddedService,
    private authenticationService: AuthenticationService,
    private supersetDashboardService: SupersetDashboardService
  ) {

  }

  ngOnInit(): void {
    this.supersetDashboardService.getDashboard(this.dashboardId).subscribe({
      next: (response: any) => {
        this.dashboardOriginalId = response.data.sdkId;

        if (!this.dashboardOriginalId) {
          console.error('No se recibió sdkId del dashboard');
          return;
        }

        this.loadDashboard();
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }

  private loadDashboard(): void {
    const mountPoint = document.getElementById('superset_embedding_div_class');

    if (!mountPoint) {
      console.error('No se encontró el contenedor de Superset');
      return;
    }

    embedDashboard({
      id: this.dashboardOriginalId,
      supersetDomain: this.supersetUrl,
      mountPoint,
      fetchGuestToken: () =>
        new Promise((resolve, reject) => {
          this.supersetService.getGuest(this.dashboardId).subscribe({
            next: (response: any) => resolve(response.data.token),
            error: err => reject(err)
          });
        }),
      dashboardUiConfig: {
        hideTitle: true,
        hideChartControls: true,
        hideTab: true,
        filters: {
          visible: false,
          expanded: false
        }
      }
    });
  }
}